import React, { useState, useEffect } from 'react';
import styles from './PainelPedidos.module.css';
import CardPedidosAtivos from '../../cozinha/components/CardPedidosAtivos';
import HeaderPageEquipe from '../components/HeaderPageEquipe';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import { numeroExibicaoPedido } from '../../../shared/utils/pedido';

function PainelPedidos() {
    const [pedidos, setPedidos] = useState([]);
    const nomeEstabelecimento = localStorage.getItem("nomeEstabelecimento");

    const buscarPedidos = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL; // pega a URL do backend do .env
            const token = localStorage.getItem('token');

            const headers = {
                'Content-Type': 'application/json'
            };

            // Adicionar token ao header se existir
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            const responsePedidos = await fetch(`${API_URL}/buscapedidos`, { headers });
            if (!responsePedidos.ok) throw new Error(`Erro do servidor: ${responsePedidos.statusText}`);
            const dataPedidos = await responsePedidos.json();

            const responseItens = await fetch(`${API_URL}/buscaitenspedido`, { headers });
            if (!responseItens.ok) throw new Error(`Erro ao buscar itens: ${responseItens.statusText}`);
            const dataItens = await responseItens.json();

            const pedidosComItens = await Promise.all(dataPedidos.map(async (pedido) => {
                const itensRelacionados = dataItens.filter(item => String(item.id_pedido) === String(pedido.id_pedido));

                const itensComDetalhes = await Promise.all(itensRelacionados.map(async (item) => {
                    const responseCadaItem = await fetch(`${API_URL}/busca_cada_item?id_item=${item.id_item}`, { headers });
                    if (!responseCadaItem.ok) throw new Error(`Erro ao buscar cada item: ${responseCadaItem.statusText}`);
                    const dadosCadaItem = await responseCadaItem.json();
                    return { ...item, detalhes: dadosCadaItem };
                }));

                return { ...pedido, itens: itensComDetalhes };
            }));

            setPedidos(pedidosComItens);

        } catch (error) {
            console.log("Erro ao buscar pedidos", error.message);
        }
    };

    useEffect(() => {
        buscarPedidos();
    }, []);

    const pedidosPendentes = pedidos.filter(p => p.status === "pendente");
    const pedidosEmAndamento = pedidos.filter(p => p.status === "em andamento");
    const pedidosProntos = pedidos.filter(p => p.status === "pronto");

    const colunas = [
        { chave: 'pendente', titulo: 'Novos', lista: pedidosPendentes, classe: 'cardAtivo' },
        { chave: 'andamento', titulo: 'Em preparo', lista: pedidosEmAndamento, classe: 'cardPreparacao' },
        { chave: 'pronto', titulo: 'Prontos', lista: pedidosProntos, classe: 'cardPronto' },
    ];

    return (
        <div className={styles.painelPedidos}>
            <HeaderPageEquipe
                nomeEstabelecimento={nomeEstabelecimento}
                nomePage="Painel de Pedidos"
            />

            <main className={styles.main}>
                <div className={styles.colunas}>
                    {colunas.map((coluna) => (
                        <section key={coluna.chave} className={styles.coluna}>
                            <header className={`${styles.colunaHeader} ${styles[`colunaHeader_${coluna.chave}`]}`}>
                                <span>{coluna.titulo}</span>
                                <span className={styles.colunaContador}>{coluna.lista.length}</span>
                            </header>

                            <div className={styles.colunaLista}>
                                {coluna.lista.length > 0 ? (
                                    coluna.lista.map((pedido) => (
                                        <CardPedidosAtivos
                                            key={pedido.id_pedido}
                                            classe={coluna.classe}
                                            horario={pedido.data_pedido}
                                            mesa={pedido.id_mesa}
                                            codigo={numeroExibicaoPedido(pedido)}
                                            itens={pedido.itens || []}
                                        />
                                    ))
                                ) : (
                                    <p className={styles.colunaVazia}>Nada por aqui</p>
                                )}
                            </div>
                        </section>
                    ))}
                </div>
            </main>

            <FooterOpcoes typeView="equipe" />
        </div>
    );
}

export default PainelPedidos;
